<template>
  <div class="customInputGroup">
    <v-text-field :value="value"
                  :type="getType"
                  class="customFormInput"
                  v-bind="$attrs"
                  v-on ="$listeners"
                  @input="onInput($event)">
      <template slot="label">
        {{label}}
      </template>
      <template slot="append">
        <div :class="getImage"
              @click="changeVisibility"/>
      </template>
    </v-text-field>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
    changeVisibility() {
      this.visible = !this.visible;
    },
  },
  computed: {
    getVisible() {
      return this.visible;
    },
    getType() {
      return this.visible ? 'text' : 'password';
    },
    getImage() {
      if (this.getVisible) {
        return [this.$style.eye, this.$style.eyeVisible];
      }

      return this.$style.eye;
    },
  },
};
</script>

<style lang="scss" module>
.eye {
  width: 18px;
  height: auto;
  background-image: url('@/assets/icons/eye-off.png');
  background-size: cover;
  background-position: center;

  &.eyeVisible {
    background-image: url('@/assets/icons/eye.png');
  }
}
</style>

<style lang="scss">
.customInputGroup {
  .customFormInput {

    .v-input__append-inner {
      position: absolute;
      top: 46px;
      right: 12px;
      width: 18px;
      height: 16px;
      margin: 0;
      padding: 0;
      opacity: 0.4;
      cursor: pointer;
    }
  }
}
</style>
